import {ApiEndpointUrl} from "../../common";
export const newsPoint = {
    list: ApiEndpointUrl + "newslist",
    blog: ApiEndpointUrl + "bloglist",
};
